/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Favourite_AddInputs */

const en_favourite_add = /** @type {(inputs: Favourite_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add to favourites`)
};

const de_favourite_add = /** @type {(inputs: Favourite_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu Favoriten hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add to favourites" |
*
* @param {Favourite_AddInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const favourite_add = /** @type {((inputs?: Favourite_AddInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Favourite_AddInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_favourite_add(inputs)
	return en_favourite_add(inputs)
});